import { ScheduleActivitySlot } from './../_models/schedule-activity-slot';
import { Observable } from 'rxjs';
import {SCHEDULE_ACTIVITY_SLOT_STORE_NAME, SCHEDULE_ACTIVITY_SLOT_STORE_DATE_INDEX, SCHEDULE_ACTIVITY_SLOT_STORE_SYNC_STATUS_INDEX } from './DbService';
import {DbService} from './DbService';

class AttendanceService {

  dbservice:DbService = new DbService()
  constructor(){
    this.dbservice.connect()
  }

  saveAttendance(scheduleActivitySlot: ScheduleActivitySlot): any {
    return this.dbservice.save(SCHEDULE_ACTIVITY_SLOT_STORE_NAME, scheduleActivitySlot);
  }

  updateAttendance(scheduleActivitySlot: ScheduleActivitySlot): any {
    return this.dbservice.update(SCHEDULE_ACTIVITY_SLOT_STORE_NAME, scheduleActivitySlot);
  }

  getScheduleActivitySlotsByDate(date: string): Promise<ScheduleActivitySlot[]> {
    return this.dbservice.getByIndex(SCHEDULE_ACTIVITY_SLOT_STORE_NAME, SCHEDULE_ACTIVITY_SLOT_STORE_DATE_INDEX, date);
  }

  getScheduleActivitySlotsBySyncStatus(syncStatus: number): Promise<ScheduleActivitySlot[]> {
    return this.dbservice.getByIndex(SCHEDULE_ACTIVITY_SLOT_STORE_NAME, SCHEDULE_ACTIVITY_SLOT_STORE_SYNC_STATUS_INDEX, syncStatus);
  }

}

export default new AttendanceService
